const NOTE_GLYPHS = ['♪', '♫', '♩', '♬', '✦', '✧'];

export class ParticleSystem {
  constructor() {
    this.particles = [];
    this.ripples = [];
  }

  burst(x, y, color, count = 18) {
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
      const speed = 1.4 + Math.random() * 3.2;
      const isStar = i % 4 === 0;
      this.particles.push({
        x,
        y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - (isStar ? 2.2 : 1.4),
        life: 1,
        maxLife: 0.65 + Math.random() * 0.55,
        color,
        glyph: isStar ? '✦' : NOTE_GLYPHS[i % NOTE_GLYPHS.length],
        size: isStar ? 8 + Math.random() * 6 : 11 + Math.random() * 9,
        spin: (Math.random() - 0.5) * 0.12,
        rot: Math.random() * Math.PI,
      });
    }
  }

  addRipple(x, y, color) {
    this.ripples.push({ x, y, color, start: performance.now(), duration: 700 });
  }

  burstMany(points, color) {
    for (const p of points) {
      this.burst(p.x, p.y, color, 12);
      this.addRipple(p.x, p.y, color);
    }
  }

  update(dt) {
    const step = dt / 16;
    this.particles = this.particles.filter((p) => {
      p.x += p.vx * step;
      p.y += p.vy * step;
      p.vy += 0.07 * step;
      p.rot += p.spin * step;
      p.life -= dt / (p.maxLife * 1000);
      return p.life > 0;
    });
    const now = performance.now();
    this.ripples = this.ripples.filter((r) => now - r.start < r.duration);
  }

  draw(ctx, now = performance.now()) {
    for (const r of this.ripples) {
      const t = (now - r.start) / r.duration;
      const radius = 6 + t * 52;
      ctx.save();
      ctx.globalAlpha = Math.max(0, 1 - t) * 0.6;
      ctx.strokeStyle = r.color;
      ctx.lineWidth = 3.5 - t * 2;
      ctx.beginPath();
      ctx.arc(r.x, r.y, radius, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    }

    for (const p of this.particles) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = Math.max(0, p.life);
      ctx.fillStyle = p.color;
      ctx.font = `900 ${p.size}px Nunito, serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.shadowColor = p.color;
      ctx.shadowBlur = 14;
      ctx.fillText(p.glyph, 0, 0);
      ctx.restore();
    }
  }
}
